import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
    useContext,
    useEffect,
} from 'react'

import DataElement from '../../../../../../Components/DataElement'

import ApplicantDataFormContext from '../../../../../../Contexts/ApplicantDataFormContext'
import StatusIcon from '../../../../../../Components/Common/StatusIcon'

import ExpandableComponentContext from '../../../../../../Contexts/ExpandableComponentContext'

const IdentityInformation = forwardRef(({ title, attributes, data, isSelected, handleFieldSelection }, ref) => {

    const dataElementRef = useRef()
    const [isOpen, setIsOpen] = useState(isSelected)

    const [completed, setCompleted] = useState(false)

    useEffect(() => {
        setIsOpen(isSelected)
    }, [isSelected])

    const applicantDataForm = useContext(ApplicantDataFormContext)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const identityInformationResult = dataElementRef.current.validateAndGetData()

            applicantDataForm.current["identity_information.current_address"] = identityInformationResult.value.current_address

            const isValid = identityInformationResult.isValid

            setCompleted(isValid)

            return identityInformationResult
        },
    }))

    const handleOpen = () => {
        if (isOpen) {
            setCompleted(dataElementRef.current.validateAndGetData().isValid)
        }
        if (isSelected) {
            setIsOpen(!isOpen)
            return
        }
        handleFieldSelection()
    }

    return (
        <div className="mb-4">

            <button
                onClick={handleOpen}
                className="w-full flex justify-between items-center py-2 px-0"
            >
                <span className="text-lg font-semibold">{title}</span>
                <span className={`pr-4 flex items-center gap-1`}> <StatusIcon isOpen={isOpen} completed={completed} /> {isOpen ? '▲' : '▼'}</span>
            </button>
            <div className={`${!isOpen ? 'hidden' : ''} pt-2`}>
                <ExpandableComponentContext.Provider value={{
                    isInteracted: isOpen
                }}>
                    <DataElement
                        ref={dataElementRef}
                        attributes={attributes}
                        data={data}
                    />
                </ExpandableComponentContext.Provider>

            </div>
        </div>
    )
})

export default IdentityInformation
